import { render } from "./Mape.component.vue?vue&type=template&id=8a861106&scoped=true"
const script = {}

import "./Mape.component.vue?vue&type=style&index=0&id=8a861106&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a861106"]])

export default __exports__